import { gql } from 'graphql-request';

export const getDictionaries = gql`
  query GetDictionaries(
    $page: Int = 1
    $pageSize: Int = 20
    $filters: DictionaryFilterInput
    $ordering: String
  ) {
    getDictionaries(
      page: $page
      pageSize: $pageSize
      filters: $filters
      ordering: $ordering
    ) {
      count
      next
      previous
      results {
        id
        traditional
        simplified
        pinyinNumbers
        pinyinMarks
        pinyin
        translation
        level
        frequency
        idiom
        simptradsame
        variant
        dictFreq
        pos
      }
      totalPages
    }
  }
`;

export const getDictionary = gql`
  query GetDictionary($id: Int!) {
    getDictionary(id: $id) {
      id
      traditional
      simplified
      pinyinNumbers
      pinyinMarks
      pinyin
      translation
      level
      frequency
      idiom
      simptradsame
      variant
      dictFreq
      pos
      skills {
        id
        name
      }
    }
  }
`;

export const getRandomDictionaries = gql`
  query GetRandomDictionaries(
    $number: Int = 1
    $notChar: [Int!]
    $char: String
    $skill: Int
    $frequency: Int
    $idiom: Boolean = false
    $mw: Boolean = false
    $minChars: Int
    $maxChars: Int
    $requireOverlap: Boolean = false # Add parameter definition
  ) {
    getRandomDictionaries(
      number: $number
      notChar: $notChar
      char: $char
      skill: $skill
      frequency: $frequency
      idiom: $idiom
      mw: $mw
      minChars: $minChars
      maxChars: $maxChars
      requireOverlap: $requireOverlap # Add to query
    ) {
      id
      simplified
      pinyinNumbers
      pinyinMarks
      translation
      level
      traditional
      dictFreq
      fromDictionary {
        id
        simplified
        pinyinNumbers
        pinyinMarks
        translation
        level
        traditional
        simptradsame
        pos
      }
      components {
        id
        traditional
        simplified
        pinyinNumbers
        pinyinMarks
        translation
        level
        frequency
        idiom
        disabled
        simptradsame
        variant
        pos
      }
      disabled
      frequency
      simptradsame
      pos
    }
  }
`;

export const fuzzySearch = gql`
  query FuzzySearch(
    $simplified: String
    $traditional: String
    $translation: String
    $pinyin: String
    $limit: Int = 10
  ) {
    fuzzySearch(
      simplified: $simplified
      traditional: $traditional
      translation: $translation
      pinyin: $pinyin
      limit: $limit
    ) {
      id
      traditional
      simplified
      pinyinMarks
      pinyinNumbers
      translation
      definition
      level
      frequency
      pos
      simptradsame
      skill
      fromDictionary {
        id
        simplified
        pinyinMarks
        pinyinNumbers
        translation
        level
        traditional
        simptradsame
        pos
      }
      components {
        id
        traditional
        simplified
        pinyinNumbers
        pinyinMarks
        translation
        level
        frequency
        idiom
        disabled
        simptradsame
        variant
        pos
      }
    }
  }
`;
